import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { BatchTestClaimTypes } from "@/types";

export interface BatchTestClaimState {
  batchTestClaim: BatchTestClaimTypes.BatchTestClaim;
}

const DEFAULT_GET_TEST_CLAIM_STATE: BatchTestClaimState = {
  batchTestClaim: {
    created_at: "",
    id: null,
    original_name: "",
    status: "",
  },
};

export default (state: BatchTestClaimState = DEFAULT_GET_TEST_CLAIM_STATE, action: Action): BatchTestClaimState => {
  if (action.type === ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_RESULTS) {
    return {
      ...state,
      batchTestClaim: action.payload,
    };
  } else {
    return state;
  }
};
